import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IpService {
  private cleanHttp: HttpClient;
  private ip$: Observable<string>;

  constructor(private handler: HttpBackend) {
    this.cleanHttp = new HttpClient(handler);

    this.ip$ = this.cleanHttp
      .get<{ ip: string }>('https://api.ipify.org/?format=json', {
        withCredentials: false
      })
      .pipe(
        map(res => res.ip),
        shareReplay(1)
      );
  }

  getIPAddress(): Observable<string> {
    return this.ip$;
  }
}
